const M_INDICADORES_CTWA = ["ctwa", "ctwa_ad", "fb_ads", "facebook", "instagram", "ig_ads", "ads"]

/**
 * @param {*} xValor
 * @returns {string}
 */
const textoTrimadoObter = (xValor) => {
  if (xValor == null) return ""
  return String(xValor).trim()
}

/**
 * @param {string} cValor
 * @returns {boolean}
 */
const anuncioCtwaOrigemEh = (cValor) => {
  const cNormalizado = textoTrimadoObter(cValor).toLowerCase()
  if (!cNormalizado) return false
  return M_INDICADORES_CTWA.some((cIndicador) => cNormalizado === cIndicador || cNormalizado.includes(cIndicador))
}

/**
 * @param {*} xThumbnail
 * @returns {string}
 */
const thumbnailDataUrlMontar = (xThumbnail) => {
  if (!xThumbnail) return ""

  if (typeof xThumbnail === "string") {
    const cTrim = xThumbnail.trim()
    if (!cTrim) return ""
    if (cTrim.startsWith("data:")) return cTrim
    return `data:image/jpeg;base64,${cTrim}`
  }

  let mBytes = null
  if (Array.isArray(xThumbnail)) {
    mBytes = xThumbnail
  } else if (xThumbnail.type === "Buffer" && Array.isArray(xThumbnail.data)) {
    mBytes = xThumbnail.data
  } else if (xThumbnail instanceof Uint8Array) {
    mBytes = Array.from(xThumbnail)
  }

  if (!mBytes || mBytes.length === 0) return ""

  let cMime = "image/jpeg"
  if (mBytes[0] === 0x89 && mBytes[1] === 0x50) cMime = "image/png"
  else if (mBytes[0] === 0x47 && mBytes[1] === 0x49) cMime = "image/gif"
  else if (mBytes[0] === 0x52 && mBytes[1] === 0x49) cMime = "image/webp"

  let cBinario = ""
  for (let nIndice = 0; nIndice < mBytes.length; nIndice += 1) {
    cBinario += String.fromCharCode(mBytes[nIndice])
  }

  return `data:${cMime};base64,${btoa(cBinario)}`
}

/**
 * @param {object} oParsed
 * @returns {object|null}
 */
const mensagemWhatsappLocalizar = (oParsed) => {
  if (oParsed && typeof oParsed === "object" && oParsed.message && typeof oParsed.message === "object") {
    return oParsed.message
  }
  return oParsed
}

/**
 * @param {object} oMessage
 * @returns {object|null}
 */
const contextInfoLocalizar = (oMessage) => {
  if (!oMessage || typeof oMessage !== "object") return null
  if (oMessage.contextInfo && typeof oMessage.contextInfo === "object") {
    return oMessage.contextInfo
  }

  const mChaves = Object.keys(oMessage)
  for (let nIndice = 0; nIndice < mChaves.length; nIndice += 1) {
    const oValor = oMessage[mChaves[nIndice]]
    if (oValor && typeof oValor === "object" && oValor.contextInfo && typeof oValor.contextInfo === "object") {
      return oValor.contextInfo
    }
  }

  return null
}

/**
 * @param {object|null} oContextInfo
 * @param {object|null} oMessage
 * @param {object} oParsed
 * @param {string} cCampo
 * @returns {string}
 */
const conversionCampoObter = (oContextInfo, oMessage, oParsed, cCampo) => {
  const mFontes = [oContextInfo, oMessage, oParsed]
  for (let nIndice = 0; nIndice < mFontes.length; nIndice += 1) {
    const oFonte = mFontes[nIndice]
    if (oFonte && oFonte[cCampo]) return oFonte[cCampo]
  }
  return ""
}

/**
 * Extrai metadado CTWA (anúncio Facebook/Instagram) do dataJson da mensagem.
 * Card quando externalAdReply está completo; fallback quando só a origem CTWA existe.
 *
 * @param {string|object|null|undefined} cDataJson
 * @returns {{ modo: 'card', cTitulo: string, cImagemUrl: string, cSourceUrl: string, cBody: string }|{ modo: 'fallback', cTexto: string }|null}
 */
export function mensagemAnuncioCtwaExtrair(cDataJson) {
  if (cDataJson == null || cDataJson === "") return null

  let oParsed = null
  if (typeof cDataJson === "object") {
    oParsed = cDataJson
  } else if (typeof cDataJson === "string") {
    try {
      oParsed = JSON.parse(cDataJson)
    } catch {
      return null
    }
  } else {
    return null
  }

  if (!oParsed || typeof oParsed !== "object") return null

  const oMessage = mensagemWhatsappLocalizar(oParsed)
  const oContextInfo = contextInfoLocalizar(oMessage)
  const oAd = oContextInfo?.externalAdReply || null

  const cTitulo = textoTrimadoObter(oAd?.title)
  const cThumbnailUrl = textoTrimadoObter(oAd?.thumbnailUrl)
  const cMediaUrl = textoTrimadoObter(oAd?.mediaUrl)
  const cImagemUrl = cThumbnailUrl || cMediaUrl || thumbnailDataUrlMontar(oAd?.thumbnail)
  const cSourceUrl = textoTrimadoObter(oAd?.sourceUrl)
  const cBody = textoTrimadoObter(oAd?.sourceText) || textoTrimadoObter(oAd?.body)

  if (cTitulo && cImagemUrl && cSourceUrl) {
    return {
      modo: "card",
      cTitulo,
      cImagemUrl,
      cSourceUrl,
      cBody,
    }
  }

  const cConversionSource = conversionCampoObter(oContextInfo, oMessage, oParsed, "conversionSource")
  const cEntryPoint = conversionCampoObter(oContextInfo, oMessage, oParsed, "entryPointConversionSource")

  if (anuncioCtwaOrigemEh(cConversionSource) || anuncioCtwaOrigemEh(cEntryPoint)) {
    return {
      modo: "fallback",
      cTexto: "Origem: anúncio Facebook/Instagram",
    }
  }

  return null
}
